module.exports = __webpack_public_path__ + "static/media/minimized.7cd64766.svg";